import React from 'react'
import { connect } from 'react-redux'
import t from 'tcomb-form'
import {
  WebsiteRefinement,
  WebsiteTransformer,
} from '../utils/tcomb-utils'
import {
  doSaveOrganizationApplication
} from '../actions'

const YearsInBusiness = t.enums({
  1: "One year or less",
  5: "1 to 5 years",
  10: "5 to 10 years",
  15: "10 to 15 years",
  20: "15 to 20 years",
  100: "Over 20 years"
})

const ProfitType = t.enums({
  nonprofit: "Non Profit",
  forprofit: "For Profit"
})

const IsWomenExclusive = t.enums({
  yes: "Yes",
  no: "No"
})

const NewOrganizationApplicationSchema = t.struct({
  name: t.String,
  website: WebsiteRefinement,
  years_in_business: YearsInBusiness,
  services: t.String,
  profit_type: ProfitType,
  is_women_exclusive: IsWomenExclusive,
  pitch: t.maybe(t.String)
});


const formOptions = {
  auto: 'none',
  fields: {
    name: {
      error: 'Please provide the name of your organization',
      attrs: {
        placeholder: 'What is the name of your organization?',
        error: 'this field is required'
      }
    },
    website: {
      error: 'Please provide be a valid website address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'What is your web address?'
      }
    },
    years_in_business: {
      error: 'Please choose length of business',
      nullOption: { value: '', text: 'Length of time in business' }
    },

    services: {
      error: 'This field is required',
      attrs: {
        placeholder: 'What do you do?'
      }
    },
    profit_type: {
      error: 'Please select one of the two',
      factory: t.form.Radio,
      label: 'Is your organization'
    },
    is_women_exclusive: {
      error: 'Please select one of the two',
      factory: t.form.Radio,
      label: 'Do you provide services exclusively for women'
    },
    pitch: {
      type: 'textarea',
      attrs: {
        placeholder: 'Why do you think your services should be listed on the WorldWideWomen website'
      }

    }
  }
};


function mapStateToProps(state) {
  return {
    user: state.auth.user,
    applyOrganization: state.applyOrganization
  }
}

@connect(mapStateToProps, { doSaveOrganizationApplication})
class NewOrganizationApplicationForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formOptions: formOptions,
      formValue: {}
    }
  }

  onFormChange = (formValue) => {
    this.setState({formValue})
  }

  resetForm = () => {
    this.setState({formValue: {
      name: '',
      website: '',
      years_in_business: null,
      services: '',
      profit_type: null,
      is_women_exclusive: null,
      pitch: ''
    }, formOptions})
  }

  saveApplication = (event) => {
    event.preventDefault()
    const value = this.refs.applyForm.getValue()
    if (value) {
      var newValue = Object.assign({}, value);
      newValue.is_non_profit = (newValue.profit_type == 'nonprofit')? true : false;
      newValue.is_women_exclusive = (newValue.is_women_exclusive == 'yes')? true : false;
      console.info('value ====>', newValue)
      this.props.doSaveOrganizationApplication(newValue);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.applyOrganization.saved) {
      this.resetForm()
    }
  }

  componentWillUnmount() {
    this.resetForm()
  }

  render() {
    let { user } = this.props
    return (
      <form className="newOrganizationApplicationForm" onSubmit={this.saveApplication}> <div className="newOrganizationApplicationFormHeading">Apply to list</div>
        <t.form.Form ref="applyForm" onChange={this.onFormChange} value={this.state.formValue} type={NewOrganizationApplicationSchema} options={this.state.formOptions} />
        <button className="button-primary" type="submit">Submit</button>
      </form>
    )
  }
}

export default NewOrganizationApplicationForm



// WEBPACK FOOTER //
// ./src/components/NewOrganizationApplicationForm.jsx